// extracted by mini-css-extract-plugin
module.exports = {"bmCheckbox":"CustomCheckbox_bmCheckbox__1mn5r","bmCheckInput":"CustomCheckbox_bmCheckInput__3FMIF","bmCheckOther":"CustomCheckbox_bmCheckOther__19ppn"};